module.exports = "/images/FilledRefundPolicy.svg?043f60b02f4224905ca63f968cf15f02";